export const FooterListData = {
  PrimaryLists: [
    {
      key: 1,
      Heading: 'Documentation',
      Links: [
        {
          key: 1,
          Text: 'About',
          Url: '',
        },
      ],
    },
    {
      key: 2,
      Heading: 'Support',
      Links: [
        {
          key: 1,
          Text: 'Contact Us',
          Url: '',
        },
      ],
    },
  ],
  SecondaryLists: [],
};
